"use client";
import React from "react";
import { cn } from "@/lib/utils";
import { buttonVariants } from "../ui/button";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { languages } from "@/app/i18n/settings";
const OrderSelection = dynamic(() => import("../selections/order-selection"), {
    ssr: false,
    loading: () => <LoadingComponent />,
});
import { ChevronDown } from "lucide-react";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

interface Props {
    sortDataSource: string[];
    sortDefault: string;
}
interface LoadingProps {
    title?: string;
}

const LoadingComponent = ({ title= "title-ascending" }: LoadingProps) => {
    const pathName = usePathname();
    const lng = languages.find((l) => pathName.startsWith(`/${l}`)) ?? "th";
    const translation: { [key: string]: { [key: string]: string } } = {
        en: {
            "manual": "Featured",
            "best-selling": "Best selling",
            "title-ascending": "Sort by A-Z",
            "title-descending": "Sort by Z-A",
            "price-ascending": "Price low to high",
            "price-descending": "Price high to low",
            "created-descending": "Sort by Newest - Oldest",
        },
        th: {
            "manual": "แนะนำ",
            "best-selling": "ขายดี",
            "title-ascending": "เรียงตามตัวอักษร A-Z",
            "title-descending": "เรียงตามตัวอักษร Z-A",
            "price-ascending": "ราคา จากต่ำไปสูง",
            "price-descending": "ราคา จากสูงไปต่ำ",
            "created-descending": "เรียงจากใหม่ล่าสุด",
        },
    };
    title = translation[lng][title as keyof typeof translation["en"]];
    const colorStyle = useContext(ColorStyleContext);
    return (
        <div
            className={cn(
                buttonVariants({ variant: "outline" }),
                "h-8 focus-visible:ring-0 focus-visible:ring-offset-0 gap-x-2 justify-center",
            )}
            style={{ color: colorStyle.text || "#3d3d3d" }}>
            {title}
            <ChevronDown className="h-4 w-4 opacity-90" />
        </div>
    );
};

const CollectionListOrderSelectionClient = ({ sortDataSource, sortDefault }: Props) => {
    const { hasMouseMoved } = useMouseMovement();
    return hasMouseMoved ? (
        <OrderSelection
            className={cn(
                buttonVariants({ variant: "outline" }),
                "h-8 focus-visible:ring-0 focus-visible:ring-offset-0 gap-x-2 justify-center",
            )}
            sortDataSource={sortDataSource}
            sortDefault={sortDefault}
        />
    ) : (
        <LoadingComponent title={"title-ascending"} />
    );
};

export default CollectionListOrderSelectionClient;
